var render = function render(){var _vm=this,_c=_vm._self._c;return _c('share-entity-dialog',{ref:"base",attrs:{"collection":"blocks","title":_vm.$t('common.share_block'),"shared-toast":_vm.$t('common.block_shared')}})
}
var staticRenderFns = []

export { render, staticRenderFns }